import React from 'react';
import { Box, Container, Typography, Link, Divider, Stack } from '@mui/material';
import Email from '@mui/icons-material/Email';
import Phone from '@mui/icons-material/Phone';
import PersonOutline from '@mui/icons-material/PersonOutline';
import School from '@mui/icons-material/School';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        mt: 'auto',
        py: 4,
      }}
    >
      <Container maxWidth="xl">
        <Stack spacing={3}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 3, md: 6 }}
            justifyContent="space-between"
          >
            <Box>
              <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75 }}>
                <School sx={{ fontSize: 24, color: 'primary.main' }} />
                <Typography variant="h6" fontWeight={600}>
                  ClearCollect
                </Typography>
              </Stack>
              <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 300 }}>
                Streamlining school fee payments, field trips, and activity registrations for students and families.
              </Typography>
            </Box>

            <Box>
              <Typography variant="subtitle2" gutterBottom fontWeight={600}>
                Contact Us
              </Typography>
              <Stack spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <PersonOutline sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    Giulia Rabitto
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Email sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Link href="mailto:grabbito@soliantconsulting.com" color="text.secondary" underline="hover" variant="body2">
                    grabbito@soliantconsulting.com
                  </Link>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Phone sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Link href="tel:+13127247642" color="text.secondary" underline="hover" variant="body2">
                    312-724-7642
                  </Link>
                </Stack>
              </Stack>
            </Box>

            <Box>
              <Typography variant="subtitle2" gutterBottom fontWeight={600}>
                Quick Links
              </Typography>
              <Stack spacing={0.5}>
                <Link href="#" color="text.secondary" underline="hover" variant="body2">
                  Payment Policies
                </Link>
                <Link href="#" color="text.secondary" underline="hover" variant="body2">
                  Fee Schedule
                </Link>
                <Link href="#" color="text.secondary" underline="hover" variant="body2">
                  Financial Assistance
                </Link>
                <Link href="#" color="text.secondary" underline="hover" variant="body2">
                  Help & Support
                </Link>
              </Stack>
            </Box>
          </Stack>

          <Divider />

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body2" color="text.secondary">
              © {currentYear} ClearCollect. All rights reserved.
            </Typography>
            <Stack direction="row" spacing={2}>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                Privacy Policy
              </Link>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                Terms of Service
              </Link>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                Accessibility
              </Link>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};
